// extracted by mini-css-extract-plugin
export var sliderRange = "_ck-2";
export var sliderRoot = "_ck-0";
export var sliderThumb = "_ck-3";
export var sliderTrack = "_ck-1";